export default "__VITE_ASSET__lgMmqZZK__"